// Autogenerated file
export const extendedPropertyFlagsEnum = {
    Invisible: "Invisible",
    ShowInMobileApp: "ShowInMobileApp",
    Required: "Required",
    ClearAtCopy: "ClearAtCopy",
    ShowInEmptyMileageBids: "ShowInEmptyMileageBids",
};
export const extendedPropertyFlags = [
    { label: "Невидимое поле", value: "Invisible", intValue: 1 },
    { label: "Показывать в мобильном приложении", value: "ShowInMobileApp", intValue: 2 },
    { label: "Обязательное", value: "Required", intValue: 4 },
    { label: "Очищать поле при копировании", value: "ClearAtCopy", intValue: 8 },
    { label: "Отображать в порожних заявках", value: "ShowInEmptyMileageBids", intValue: 16 },
];
